import { CharacteristicTagList } from '@findy-code/yuffie/shared/job-description/characteristic-tag-list';
import { CombinedSkillTagList } from '@findy-code/yuffie/shared/job-description/skill-tag-list';
import {
  Code,
  Stat0,
  UniversalCurrencyAlt,
  Work,
} from '@findy-code/yuffie/ui/icon';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';

import { salaryRangeText } from '../../utils';
import styles from './job-highlight.module.scss';

const MAX_SKILLS_LENGTH = 5;
const MAX_CHARACTERISTICS_LENGTH = 3;

type Props = {
  jobTypeName: string | undefined;
  managementJobTypeName: string | undefined;
  numericSalaryMin: number | null | undefined;
  numericSalaryMax: number | null | undefined;
  skills: {
    id: number;
    name: string;
  }[];
  userSkillIds: number[];
  userSelfRecommendedSkillIds: number[];
  jobDescriptionsCharacteristics: {
    id: number;
    name: string;
    isMatched?: boolean;
  }[];
};
export const JobHighlight = ({
  jobTypeName,
  managementJobTypeName,
  numericSalaryMin,
  numericSalaryMax,
  skills,
  jobDescriptionsCharacteristics,
  userSkillIds,
  userSelfRecommendedSkillIds,
}: Props) => {
  return (
    <Stack
      align="start"
      className={styles.container}
      spacing="s"
      // デザイン上の調整
      // 当コンポーネントをHeaderコンポーネントに組み込むのは億劫だったためこの形で対応
      style={{ marginTop: '-20px' }}
    >
      <Stack align="center" className={styles.row} direction="row" spacing="s">
        <div className={styles.labelWrapper} style={{ marginBottom: 'auto' }}>
          <Work />
          <Text className={styles.label} font="body-s">
            職種
          </Text>
        </div>
        <Text font="heading-m">
          {jobTypeName}
          {jobTypeName && managementJobTypeName && (
            <span className={styles.delimitation}>/</span>
          )}
          {managementJobTypeName}
        </Text>
      </Stack>
      {(numericSalaryMin || numericSalaryMax) && (
        <Stack
          align="center"
          className={styles.row}
          direction="row"
          spacing="s"
        >
          <div className={styles.labelWrapper}>
            <UniversalCurrencyAlt />
            <Text className={styles.label} font="body-s">
              年収
            </Text>
          </div>
          <Text font="heading-m">
            {salaryRangeText(
              numericSalaryMin,
              numericSalaryMax,
              0.0001,
              '万円'
            )}
          </Text>
        </Stack>
      )}
      {skills.length > 0 && (
        <Stack
          align="center"
          className={styles.row}
          direction="row"
          spacing="s"
        >
          <div className={`${styles.labelWrapper} ${styles.fixedHeight}`}>
            <Code />
            <Text className={styles.label} font="body-s">
              利用技術
            </Text>
          </div>
          <CombinedSkillTagList
            gitHubRepoDerivedUserSkillIds={userSkillIds}
            maxSkillTagDisplayCount={MAX_SKILLS_LENGTH}
            skills={skills}
            userSelfRecommendedSkillIds={userSelfRecommendedSkillIds}
          />
        </Stack>
      )}
      {jobDescriptionsCharacteristics.length > 0 && (
        <Stack
          align="center"
          className={styles.row}
          data-testid="characteristic-tag-list"
          direction="row"
          spacing="s"
        >
          <div className={`${styles.labelWrapper} ${styles.fixedHeight}`}>
            <Stat0 />
            <Text className={styles.label} font="body-s">
              こだわり条件
            </Text>
          </div>
          <CharacteristicTagList
            characteristics={jobDescriptionsCharacteristics}
            maxCount={MAX_CHARACTERISTICS_LENGTH}
          />
        </Stack>
      )}
    </Stack>
  );
};
